export const isAndroid = /android/i.test(navigator.userAgent);

export const isTouchDevice =
    window.ontouchstart != null ||
    navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i);
